var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row full-height", attrs: { id: "dualList" } },
    [
      _c(
        "q-list",
        { staticClass: "col-5", attrs: { id: "leftList" } },
        _vm._l(_vm.leftList, function(leftItem, index) {
          return _c(
            "q-item",
            {
              key: index,
              class: { active: _vm.selectedLeftIndex === index },
              nativeOn: {
                click: function($event) {
                  _vm.setLeftIndex(index)
                }
              }
            },
            [_c("q-item-main", { attrs: { label: leftItem } })],
            1
          )
        })
      ),
      _c(
        "div",
        { staticClass: "col-2 column justify-center" },
        [
          _c("q-btn", {
            staticClass: "q-mx-md",
            attrs: { label: "All Right" },
            on: {
              click: function($event) {
                _vm.pushAllRight()
              }
            }
          }),
          _c("q-btn", {
            staticClass: "q-mx-md",
            attrs: { label: "Right" },
            on: {
              click: function($event) {
                _vm.pushRight()
              }
            }
          }),
          _c("q-btn", {
            staticClass: "q-mx-md",
            attrs: { label: "Left" },
            on: {
              click: function($event) {
                _vm.pushLeft()
              }
            }
          }),
          _c("q-btn", {
            staticClass: "q-mx-md",
            attrs: { label: "All Left" },
            on: {
              click: function($event) {
                _vm.pushAllLeft()
              }
            }
          })
        ],
        1
      ),
      _c(
        "q-list",
        { staticClass: "col-5", attrs: { id: "rightList" } },
        _vm._l(_vm.rightList, function(rightItem, index) {
          return _c(
            "q-item",
            {
              key: index,
              class: { active: _vm.selectedRightIndex === index },
              attrs: { highlight: "" },
              nativeOn: {
                click: function($event) {
                  _vm.setRightIndex(index)
                }
              }
            },
            [_c("q-item-main", { attrs: { label: rightItem } })],
            1
          )
        })
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }